import Event from "./Event";
import { apiURL } from "../helpers/url";

class Voucher extends Event {
    constructor() {
        super();
        this.apiURL = apiURL();
        this.voucher = {};
        this.promises = {
            fetchVoucher: null
        };
        this.AbortControllers = {
            fetchVoucher: []
        };
    }

    static createInstance() {
        return new this();
    }

    abortFetch(name) {
        Object.values(this.AbortControllers[name]).forEach(controller => controller.abort());
        this.AbortControllers[name] = [];
    }

    /**
     * Fetch Voucher item
     *
     * Voucher returns pending Promise if API request is pending
     *
     * @returns {Promise} Promise object with status and data
     */
    fetchVoucher(voucherCode) {
        this.publish("itemsFetching");

        this.abortFetch("fetchVoucher");
        let controller = new AbortController();
        this.AbortControllers.fetchVoucher.push(controller);

        this.promises.fetchVoucher = fetch(`${this.apiURL}/voucher?name=${voucherCode}`, {
            signal: controller.signal
        })
            .then(response => {
                return response.text().then(text => {
                    return {
                        status: response.status,
                        content: text
                    };
                });
            })
            .then(response => {
                let content = response.status < 300 ? JSON.parse(response.content) : null;

                if (content) {
                    this.voucher = content;
                    this.publish("itemsFetched", {
                        status: response.status,
                        content: content
                    });
                }
                this.promises.fetchVoucher = null;

                return {
                    status: response.status,
                    content: content
                };
            })
            .catch(error => {
                this.promises.fetchVoucher = null;
                return {
                    status: 600,
                    error: error
                };
            });

        return this.promises.fetchVoucher;
    }
}

export default Voucher;
